<template>
    <form
        class="o-login"
        @submit.prevent="handleSubmit"
    >
        <p class="a-title o-login__title">Reset hasła</p>
        <div v-if="authStatus !== 'waitingForEmail'">
            <p class="a-label o-login__label">E-mail</p>
            <div class="a-control o-login__inputLogin">
                <input
                    class="a-control__input o-login__input"
                    type="text"
                    placeholder="Wpisz e-mail..."
                    v-model="email"
                    ref="authResetPasswordStep1Input"
                >
            </div>
        </div>
        <div v-else>
            <p class="o-login__text">Na podany adres email została wysłana wiadomość z linkiem do resetu hasła.</p>
        </div>
        <div>
            <a-button
                v-if="authStatus !== 'waitingForEmail'"
                class="o-login__button"
                type="fullwidth-light"
                :is-processing="authStatus === 'pending'"
                :submit="true"
            >
                Odzyskaj hasło
            </a-button>
            <a-button
                class="o-login__button"
                type="fullwidth-light"
                :process-on-click="true"
                @click.prevent.stop="$router.push({ name: 'login' })"
            >
                Powrót
            </a-button>
            <p class="o-login__version">
                v{{ version }}
                <span v-if="environment !== 'production'">{{ environment }}</span>
            </p>
        </div>
    </form>
</template>

<script>
export default {
    metaInfo: {
        title: 'Reset hasła'
    },
    data() {
        return {
            email: ''
        }
    },
    computed: {
        version() {
            return process.env.PACKAGE_VERSION
        },
        environment() {
            return process.env.VUE_APP_MODE
        },
        authStatus() {
            return this.$store.getters.authStatus
        }
    },
    methods: {
        handleSubmit() {
            if(this.email === '') {
                this.$store.dispatch('addNotification', {
                    type: 'alert',
                    content: 'Uzupełnij wymagane pole'
                })
                this.$refs.authResetPasswordStep1Input.focus()
            } else {
                this.$store.dispatch('authResetPasswordStep1', this.email).catch((error) => {
                    this.$store.dispatch('addNotification', {
                        type: 'alert',
                        content: error.response.data.data
                    })
                })
            }
        }
    }
}
</script>
